import type { Components } from '@/api/generated/api';
import type { IAttachmentCardItem } from '@/core/attachments/AttachmentCard.vue';
import { AttachmentContentType } from 'common/enum/entry.attachment.enum';
import { immutableSort } from 'common/utils/array.utils';

/** Sort by when each file or app was linked to the entry, before applying preview limits. */
export function getEntryAttachmentCards(params: {
  files: Components.Schemas.EntryAttachmentItemDto[];
  materials: Components.Schemas.ExternalMaterialLinkDto[];
}): IAttachmentCardItem[] {
  const apps = params.materials.map((material) => ({
    id: material.externalMaterialId,
    createdAt: material.createdAt,
    type: AttachmentContentType.App,
    name: material.name,
    imageSource: material.logoId ?? material.logoUrl,
    url: material.sourceUrl,
  }));
  const files = params.files.map((file) => ({
    ...file,
    imageSource: file.type === AttachmentContentType.Image ? (file.thumbnailFileId ?? file.fileId) : null,
    url: null,
  }));
  return immutableSort(
    [...files, ...apps],
    (left, right) => new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime(),
  );
}
